var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions"},_vm._l((_vm.questions),function(question,index){return _c('QuestionsCard',{key:index,attrs:{"order":index + 1,"statement":question.statement,"content":question.content,"correct":question.correct,"active":question === _vm.activeQuestion,"variation":_vm.variation},on:{"click":function($event){return _vm.$emit('select', {
      question: question,
      questionIndex: index
    })}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }